import React, { useCallback, useState } from 'react';
import { Button, Card, Col, Form, Row } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import {
  HeaderTitle,
  // eslint-disable-next-line
  SelectWarehouse,
  FormLabel,
  message,
} from 'components/common';
import WarehouseSelector from 'components/Warehouse/WarehouseSelectBox';
import { LS_DEFAULT_WAREHOUSE_KEY } from 'constants/config';

// eslint-disable-next-line
export default () => {
  const [defaultWarehouseId, setDefaultWarehouseId] = useState<number>();
  const [inited, setInited] = useState(false);
  const [selectedWarehouse, setSelectedWarehouse] = useState<StringKAnyVPair>({});
  const [saveLoading, setSaveLoading] = useState(false);
  const [form] = Form.useForm();

  const isWarehouseSavable = () => {
    return !!(selectedWarehouse.id && selectedWarehouse.id !== defaultWarehouseId);
  };

  const onSelectWarehouse = (whId: number, wh: StringKAnyVPair) => {
    //console.log('change', whId, wh);
    setSelectedWarehouse(wh);
  };

  const saveSetting = () => {
    //console.log(selectedWarehouse);
    if (selectedWarehouse.id) {
      localStorage.setItem(
        LS_DEFAULT_WAREHOUSE_KEY,
        selectedWarehouse.id,
      );
      setDefaultWarehouseId(selectedWarehouse.id);
      message.success({ content: 'Saved successfully' });
    } else {
      message.error({ content: 'Please select a warehouse' });
    }
  };

  // eslint-disable-next-line
  const saveSetting2 = useCallback(async () => {
    const params = await form.validateFields();
    if (params.errorFields) return;
    setSaveLoading(true);
    try {
      //todo save
      localStorage.setItem(
        LS_DEFAULT_WAREHOUSE_KEY,
        params.defaultWarehouse.id
      );
      // localStorage.setItem(
      //   LS_DEFAULT_WAREHOUSE_CODE,
      //   params.defaultWarehouse.code
      // );
      // localStorage.setItem(
      //   LS_DEFAULT_WAREHOUSE_WAREHOUSEID,
      //   `${params.defaultWarehouse.warehouseId}`
      // );

      setSaveLoading(false);
      message.success({ content: 'Saved successfully' });
    } catch (error) {
      setSaveLoading(false);
    }
  }, [form]);

  // eslint-disable-next-line
  const layout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 14 },
  };

  React.useEffect(() => {
    if (!inited) {
      const id = Number(localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY));

      if (!isNaN(id)) setDefaultWarehouseId(id);

      setInited(true);
    }
  }, [inited]);

  return (
    <>
      <HeaderTitle breadcrumb={['Administration', 'Settings']}>
        <Button
          disabled={!isWarehouseSavable()}
          loading={saveLoading}
          onClick={() => saveSetting()}
          type="primary"
        >
          <SaveOutlined />
          Save
        </Button>
      </HeaderTitle>
      <Card>
        <Row align="middle">
          <Col span={6} style={{ paddingRight: 12, textAlign: 'right' }}>
            <FormLabel>Default Warehouse</FormLabel>
          </Col>
          <Col span={14}>
            <WarehouseSelector
              onChange={onSelectWarehouse}
              placeholder="Please select a default warehouse"
              sortByCreateTime={true}
              value={selectedWarehouse.id}
            />
          </Col>
        </Row>
        {/*<Form {...layout} form={form} style={{ marginTop: 20 }}>
          <Form.Item
            name="defaultWarehouse"
            label={<FormLabel>Default Warehouse</FormLabel>}
            rules={[
              { required: true, message: 'Default Warehouse is required' },
            ]}
          >
            <SelectWarehouse
              placeholder={
                localStorage.getItem(LS_DEFAULT_WAREHOUSE_KEY)
                  ? ''
                  : 'Please select a default warehouse'
              }
            />
          </Form.Item>
        </Form>*/}
      </Card>
    </>
  );
};
